import { v4 as uuid } from 'uuid';
import { Address } from "./Address.js";
import { CartItem } from "./CartItem.js";
import { DeliveryType } from "./Enums.js";
export class OrderRequest {
    id = null;
    companyId = null;
    orderId = null;
    date = null;
    cartItems = [];
    pointofsaleId = null;
    paymentType = null;
    tipPercentage = null;
    zoneId = null;
    //the delivery zone the user explicitly chose (null: the cheapest applicable one is used)
    deliveryZoneId = null;
    //the pickup location the user explicitly chose (null: the first one is used)
    pickupLocationId = null;
    name = null;
    email = null;
    phone = null;
    deliveryAddress = null;
    billingAddress = null;
    deliveryType = null;
    pickupTimeMode = null;
    pickupTime = null;
    note = null;
    usersLocale = null;
    customerName = null;
    currency = null;
    discounts = null;
    voucher = null;
    domain = null;
    //backend user id (if created by a backend user)
    userId = null;
    //frontend customer id
    customerId = null;
    createCustomerIfNoneExists = false;
    hasErrors = false;
    errors = [];
    constructor(id, data) {
        this.id = id || null;
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'deliveryAddress') {
                            let address = new Address(value);
                            if (value && !address.isComplete()) {
                                console.warn('discarding incomplete deliveryAddress', value);
                            }
                            value = address.isComplete() ? address : null;
                        }
                        if (key == 'billingAddress') {
                            let address = new Address(value);
                            if (value && !address.isComplete()) {
                                console.warn('discarding incomplete billingAddress');
                            }
                            value = address.isComplete() ? address : null;
                        }
                        if (key == 'cartItems') {
                        }
                        if (key == 'cartItems' && Object.keys(value).length > 0) {
                            let items = [];
                            for (let cartItemId in value) {
                                let item = value[cartItemId];
                                items.push(new CartItem(item.id || uuid(), item));
                            }
                            value = items;
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
    static createFromFilteredData(data) {
        let orderRequest = new OrderRequest(uuid());
        orderRequest.customerId = data.customerId || null;
        orderRequest.createCustomerIfNoneExists = data.createCustomerIfNoneExists || false;
        orderRequest.companyId = data.companyId || null;
        orderRequest.pointofsaleId = data.pointofsaleId || null;
        orderRequest.zoneId = data.zoneId || null;
        orderRequest.deliveryZoneId = data.deliveryZoneId || null;
        orderRequest.pickupLocationId = data.pickupLocationId || null;
        orderRequest.tipPercentage = data.tipPercentage || null;
        orderRequest.deliveryType = data.deliveryType || null;
        orderRequest.pickupTimeMode = data.pickupTimeMode || null;
        orderRequest.pickupTime = data.pickupTime || null;
        orderRequest.note = data.note || null;
        orderRequest.phone = data.phone || null;
        orderRequest.email = data.email || null;
        orderRequest.customerName = data.customerName || null;
        orderRequest.voucher = data.voucher || null;
        orderRequest.discounts = data.discounts || null;
        orderRequest.paymentType = data.paymentType || null;
        let deliveryAddress = new Address(data.deliveryAddress);
        if (data.deliveryAddress && !deliveryAddress.isComplete()) {
            console.warn('discarding incomplete deliveryAddress');
        }
        orderRequest.deliveryAddress = deliveryAddress.isComplete() ? deliveryAddress : null;
        let billingAddress = new Address(data.billingAddress);
        if (data.billingAddress && !billingAddress.isComplete()) {
            console.warn('discarding incomplete billingAddress');
        }
        orderRequest.billingAddress = billingAddress.isComplete() ? billingAddress : null;
        orderRequest.domain = null;
        orderRequest.userId = null;
        if (data.items) {
            //now it takes  an array as well as a map
            let dataItemValues = Object.values(data.items);
            for (let item of dataItemValues) {
                let cartItem = new CartItem(item.id || uuid());
                cartItem.note = item.note || null;
                cartItem.quantity = item.quantity || null;
                cartItem.productId = item.productId || null;
                cartItem.options = item.options || null;
                cartItem.courseId = item.courseId || null;
                cartItem.chosen = item.chosen && Object.values(item.chosen).length > 0 ? item.chosen : null;
                orderRequest.cartItems.push(cartItem);
            }
        }
        return orderRequest;
    }
}
